import { Component } from "@mna/react";
import i18next from "i18next";
import { Trans } from "react-i18next";
import i18n from "./../../../i18n";
import {  checkAndGetLocalStorageValue} from "../../../features/utils";
let lang, isQuestionLog;
let selectedId, selectedChoice;
let isAnswerAvailable = false;

async function answerClick({
  state,
  actions,
  setState,
  nextStepName,
  history,
  choice,
  item,
}) {  
  gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
  choice.label === i18next.t("findcareoption.Yes")
    ? actions.addPresentQuestion({ item })
    : choice.label === i18next.t("findcareoption.No")
    ? actions.addAbsentQuestion({ item })
    : actions.addUnknownQuestion({ item });
  await actions.postQuestions(state, actions, setState);
  if (state.Questions.should_stop === true) {
    state.triageRequest.activeMenu = nextStepName;
  }
  state.Questions.should_stop === false
    ? actions.getQuestions(
        { state, actions, setState, nextStepName, history },
        (lang = i18n.language),
        (isQuestionLog = true)
      )
    : actions.finishQuestionCallback(
        state,
        nextStepName,
        history,
        actions,
        setState,
        state.Questions,
        lang
      );
}

async function answerClickTemp({
  state,
  actions,
  setState,
  nextStepName,
  history,
  selectedChoice,
  selectedId,
}) {  
  var item = {
    id: selectedId,
  };
  var choice = {
    label: selectedChoice,
  };
  choice.label === "Yes"
    ? actions.addPresentQuestion({ item })
    : choice.label === "No"
    ? actions.addAbsentQuestion({ item })
    : actions.addUnknownQuestion({ item });
  await actions.postQuestions(state, actions, setState);
  if (state.Questions.should_stop === true) {
    state.triageRequest.activeMenu = nextStepName;
  }
  state.Questions.should_stop === false
    ? actions.getQuestions(
        { state, actions, setState, nextStepName, history },
        (lang = i18n.language),
        (isQuestionLog = true)
      )
    : actions.finishQuestionCallback(
        state,
        nextStepName,
        history,
        actions,
        setState,
        state.Questions,
        lang
      );
}

export function backClick({ state, actions, setState, nextStepName, history }) {  
  setState({
    itemSelected : false 
  })
  var lastObject =
    state.questionWithAnswers[state.questionWithAnswers.length - 1];
  for (var i = 0; i < lastObject.presentQuestionsSelected.length; i++) {
    var preIndex = state.presentQuestionsSelected.indexOf(
      lastObject.presentQuestionsSelected[i]
    );
    if (preIndex > -1) state.presentQuestionsSelected.splice(preIndex, 1);
  }
  for (var i = 0; i < lastObject.unknownQuestionsSelected.length; i++) {
    var unKnowIndex = state.unknownQuestionsSelected.indexOf(
      lastObject.unknownQuestionsSelected[i]
    );
    if (unKnowIndex > -1) state.unknownQuestionsSelected.splice(unKnowIndex, 1);
  }
  for (var i = 0; i < lastObject.absentQuestionsSelected.length; i++) {
    var absentIndex = state.absentQuestionsSelected.indexOf(
      lastObject.absentQuestionsSelected[i]
    );
    if (absentIndex > -1) state.absentQuestionsSelected.splice(absentIndex, 1);
  }
  state.questionWithAnswers.pop();

  actions.getQuestionsByOrder(
    { state, actions, setState, nextStepName, history },
    (lang = i18n.language),
    (isQuestionLog = true)
  );
  state.triageRequest.activeMenu = "questions"
}

export function backClickStatic({ state }) { 
  var lastObject =
    state.questionWithAnswers[state.questionWithAnswers.length - 1];
  for (var i = 0; i < lastObject.presentQuestionsSelected.length; i++) {
    var preIndex = state.presentQuestionsSelected.indexOf(
      lastObject.presentQuestionsSelected[i]
    );
    if (preIndex > -1) state.presentQuestionsSelected.splice(preIndex, 1);
  }
  for (var i = 0; i < lastObject.unknownQuestionsSelected.length; i++) {
    var unKnowIndex = state.unknownQuestionsSelected.indexOf(
      lastObject.unknownQuestionsSelected[i]
    );
    if (unKnowIndex > -1) state.unknownQuestionsSelected.splice(unKnowIndex, 1);
  }
  for (var i = 0; i < lastObject.absentQuestionsSelected.length; i++) {
    var absentIndex = state.absentQuestionsSelected.indexOf(
      lastObject.absentQuestionsSelected[i]
    );
    if (absentIndex > -1) state.absentQuestionsSelected.splice(absentIndex, 1);
  }
  state.questionWithAnswers.pop();
  state.orderIdArray.pop();
}

export default class Single extends Component {
  constructor() {
    super();
    this.state = {
      globalAnswerAvailable: false,
    };
  }

  componentWillMount() {    
    const { state } = this.props;

    for (var i = 0; i < state.Questions.question.items.length; i++) {
      var presentTemp = state.presentQuestionsSelectedTemp.indexOf(
        state.Questions.question.items[i].id
      );
      var absentTemp = state.absentQuestionsSelectedTemp.indexOf(
        state.Questions.question.items[i].id
      );
      var unknownTemp = state.unknownQuestionsSelectedTemp.indexOf(
        state.Questions.question.items[i].id
      );

      if (presentTemp != -1 || absentTemp != -1 || unknownTemp != -1) {
        this.setState({
          globalAnswerAvailable: true,
        });
        break;
      }
    }
  }

  componentWillUnmount() {    
    this.setState({
      globalAnswerAvailable: false,
    });
  }

  render() {
    const { state, actions, history, setState, nextStepName } = this.props;
    const uuidv4 = require("uuid/v4");
    const groupSingleId = "group_single_" + uuidv4();
    return (
      
      <div className="standby-questions-margin">
        <h1 className="text-left">
          {state.Questions.question.text}
        </h1>
        <div className="standby-col standby-col-shrink ">
          {state.Questions.question.items.map(function (item) {
            return (
              <div role="list">
                {item.choices.map(function (choice) {
                  var presentTemp = state.presentQuestionsSelectedTemp.indexOf(
                    item.id
                  );

                  var absentTemp = state.absentQuestionsSelectedTemp.indexOf(
                    item.id
                  );
                  var unknownTemp = state.unknownQuestionsSelectedTemp.indexOf(
                    item.id
                  );
                  if (
                    choice.label === i18next.t("findcareoption.Yes") &&
                    presentTemp != -1
                  ) {
                    isAnswerAvailable = true;
                    selectedId =
                      state.presentQuestionsSelectedTemp[presentTemp];
                    selectedChoice = "Yes";
                  } else if (
                    choice.label === i18next.t("findcareoption.No") &&
                    absentTemp != -1
                  ) {
                    isAnswerAvailable = true;
                    selectedId = state.absentQuestionsSelectedTemp[absentTemp];
                    selectedChoice = "No";
                  } else if (
                    choice.label === i18next.t("findcareoption.DontKnow") &&
                    unknownTemp != -1
                  ) {
                    isAnswerAvailable = true;
                    selectedId =
                      state.unknownQuestionsSelectedTemp[unknownTemp];
                    selectedChoice = "";
                  } else {
                    isAnswerAvailable = false;
                  }

                  return (
                    <div id={`list_${choice.id}`} role='listitem' className="radio-button-interview">
                    <input
                      type="radio"
                      name={groupSingleId}
                      id={choice.id}
                      key={"key_" + item.id + choice.id}
                      value={choice.label}
                      defaultChecked={
                        choice.label === i18next.t("findcareoption.Yes") &&
                        presentTemp > -1
                          ? presentTemp > -1
                          : choice.label ===
                              i18next.t("findcareoption.No") &&
                            absentTemp > -1
                          ? absentTemp > -1
                          : choice.label ===
                              i18next.t("findcareoption.DontKnow") &&
                            unknownTemp > -1
                          ? unknownTemp > -1
                          : null
                      }
                      className="standby-triagesymptom"
                      aria-label={state.Questions.question.text + " " + choice.label}
                      onChange={(e) =>{
                      //e.currentTarget.id
                      let choice = {id : e.currentTarget.id, label : e.currentTarget.value}
                      let selectedAnswer = [choice]
                        setState({
                          selectedAnswer,
                          itemSelected: item
                        })
                      }}
                    />
                   <label for={choice.id}>{choice.label}</label>
                  </div>
                  );
                }, this)}
              </div>
            );
          }, this)}
        </div>

        <div className="standby-page-section-row standby-page-section-row-flex standby-page-section-row-flex-spaced standby-page-section-row-flex-align-center standby-form-fieldset">
          <div className="standby-btn-next standby-col standby-col-shrink ">
            {state.presentQuestionsSelected.length > 0 ||
            state.unknownQuestionsSelected.length > 0 ||
            state.absentQuestionsSelected.length > 0 ? (
              <button
                type="button"
                className="button standby-button standby-button-gradient standby-button-gradient-green"
                onClick={() =>
                  backClick({ state, actions, setState, nextStepName, history })
                }
              >
                <Trans i18nKey="findcareoption.questions.Back"> Back</Trans>
              </button>
            ) : null}
              <button
                type="button"
                className="standby-btn-back button standby-button standby-button-gradient standby-button-gradient-green"
                onClick={() => {
                  if(this.state.globalAnswerAvailable){
                    if(state.selectedAnswer.length !== 0){
                      selectedChoice = state.selectedAnswer[0].label
                    }
                    answerClickTemp({
                    state,
                    actions,
                    setState,
                    nextStepName,
                    history,
                    selectedChoice,
                    selectedId,
                  })} else{
                    if(state.selectedAnswer.length !== 0 && state.itemSelected !== '')
                    {let choice = state.selectedAnswer[0];
                    let item = state.itemSelected
                    answerClick({
                      state,
                      actions,
                      setState,
                      nextStepName,
                      history,
                      choice,
                      item,
                    });
                  }
                  }
                } }
              >
                <Trans i18nKey="findcareoption.questions.Next"> Next</Trans>
              </button>
          </div>
        </div>
      </div>
    );
  }
}
